import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * Pet beds, bowls, toys, dig spots and the pet shop counter (category
 * 'pets', interaction { type: 'pet', action }). Owned by the pets feature.
 *
 * Actions: shop (adopt, supplies, vet), feed, water, play, nap, dig, walk.
 */
export const PET_FURNITURE: Record<string, FurnitureDef> = defineFurniture('pets', {
  pet_shop_counter: {
    label: 'Pet Shop Counter',
    description: 'Adopt a pet, stock up on food and toys, or see the vet.',
    price: 0,
    solid: true,
    height: 1.1,
    interaction: { type: 'pet', action: 'shop' },
  },
  pet_bed: {
    label: 'Pet Bed',
    description: 'A plush cushion. Click it for a pet nap.',
    price: 150,
    solid: false,
    height: 0.25,
    interaction: { type: 'pet', action: 'nap' },
  },
  food_bowl: {
    label: 'Food Bowl',
    description: 'Click it to feed your pet (you need some pet food).',
    price: 60,
    solid: false,
    height: 0.2,
    interaction: { type: 'pet', action: 'feed' },
  },
  water_bowl: {
    label: 'Water Bowl',
    description: 'A cool drink perks up a tired pet.',
    price: 50,
    solid: false,
    height: 0.2,
    interaction: { type: 'pet', action: 'water' },
  },
  pet_house: {
    label: 'Pet House',
    description: 'A cosy kennel with a red roof. Click for a nap.',
    price: 400,
    solid: true,
    height: 1.3,
    interaction: { type: 'pet', action: 'nap' },
  },
  scratching_post: {
    label: 'Scratching Post',
    description: 'Saves your sofa. Click to play.',
    price: 200,
    solid: true,
    height: 1.4,
    interaction: { type: 'pet', action: 'play' },
  },
  toy_ball: {
    label: 'Toy Ball',
    description: 'Bouncy and squeaky. Click to play fetch.',
    price: 40,
    solid: false,
    height: 0.2,
    interaction: { type: 'pet', action: 'play' },
  },
  bird_perch: {
    label: 'Bird Perch',
    description: 'A wooden stand with a swing. Birds love it.',
    price: 250,
    solid: true,
    height: 1.6,
    interaction: { type: 'pet', action: 'play' },
  },
  hamster_cage: {
    label: 'Hamster Cage',
    description: 'Complete with a spinning wheel.',
    price: 300,
    solid: true,
    height: 1,
    interaction: { type: 'pet', action: 'play' },
  },
  dig_spot: {
    label: 'Dig Spot',
    description: 'Soft sand. Stand here with a happy pet and ask it to dig for treasure.',
    price: 150,
    solid: false,
    height: 0,
    interaction: { type: 'pet', action: 'dig' },
  },
  grass_patch: {
    label: 'Grass Patch',
    description: 'A square of soft park grass.',
    price: 60,
    solid: false,
    height: 0,
    // Clicking grass just walks there (no info card on every step).
    interaction: { type: 'pet', action: 'walk' },
  },
  golden_bone: {
    label: 'Golden Bone Trophy',
    description: 'A rare treasure dug up by a very good pet.',
    price: 0,
    solid: true,
    height: 1.2,
  },
});
